var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * 重构整个 PP 所有 Icon 组件的逻辑指南：
 * 1. 保留 @ant-design/icons 的所有原始图标，除非在下面使用同名图标组件覆盖
 * 2. 废弃 createFromtIconfontCN 的能力，添加支持两种加载图标库的方法
 * 3. 提供 disabled 状态 和 颜色类别 colorType
 * 4. 保持 type 属性 指定使用的图标组件
 */
import React from 'react';
import { getTwoToneColor, setTwoToneColor } from '@ant-design/icons';
import IconBase from './IconBase';
import loadIcons from './loadIcons';
// 保留 @ant-design/icons 的原来的所有图标内容，以下可以使用同名重定义覆盖导出
export * from '@ant-design/icons';
// 初始化默认的 iconfont
loadIcons(() => import('./iconfont'));
export default IconBase;
// 废弃掉 @ant-design/icons 的 createFroomIconfontCN，使用 loadIcons 进行图标库加载
export const createFromIconfontCN = void 0;
export { loadIcons, setTwoToneColor, getTwoToneColor };
/**
 * 生成一类指定扩展props的图标
 */
export function createIconsWithExtraCommonProps(extraCommonProps) {
    const { type: _ } = extraCommonProps, rest = __rest(extraCommonProps, ["type"]); // 不要把 type 带给 IconBase
    return React.forwardRef((props, ref) => {
        return React.createElement(IconBase, Object.assign({ ref: ref }, props, rest));
    });
}
/**
 * 生成指定 type 的图标
 * @param type
 * @returns
 */
export function generateIcon(type, Icon = IconBase) {
    return React.forwardRef((props, ref) => {
        const { type: _ } = props, rest = __rest(props, ["type"]); // 不要把 type 带给 IconBase
        return React.createElement(Icon, Object.assign({ ref: ref, type: type }, rest));
    });
}
// 以下罗列了 pp 所有图标组件，原有的 @ant-design/icons 内置图标也可以维持不变的使用，除非以下列表有同名的图标组件覆盖掉原来的 @ant-design/icons 的图标组件。
export const ShoppingcartFIcon = generateIcon('icon-shoppingcart-f');
export const SettingFIcon = generateIcon('icon-setting-f');
export const GiftOIcon = generateIcon('icon-gift-o');
export const LaptopOIcon = generateIcon('icon-laptop-o');
export const ImportIcon = generateIcon('icon-import');
export const InfoIcon = generateIcon('icon-info');
export const LibraryvideoOIcon = generateIcon('icon-libraryvideo-o');
export const HeartrateOIcon = generateIcon('icon-heartrate-o');
export const GridhorizontalOIcon = generateIcon('icon-gridhorizontal-o');
export const GridveticalOIcon = generateIcon('icon-gridvetical-o');
export const ListOIcon = generateIcon('icon-list-o');
export const LocationarrowOIcon = generateIcon('icon-locationarrow-o');
export const LockIcon = generateIcon('icon-lock');
export const ListSignOIcon = generateIcon('icon-list-sign-o');
export const LoadingOIcon = generateIcon('icon-loading');
export const MapOIcon = generateIcon('icon-map-o');
export const ManualOIcon = generateIcon('icon-manual-o');
export const ListCancelledOIcon = generateIcon('icon-list-cancelled-o');
export const MapmarkerOIcon = generateIcon('icon-mapmarker-o');
export const ListPendingOIcon = generateIcon('icon-list-pending-o');
export const MedalOIcon = generateIcon('icon-medal-o');
export const ListSearchOIcon = generateIcon('icon-list-search-o');
export const ListIcon = generateIcon('icon-list');
export const MedicalchartOIcon = generateIcon('icon-medicalchart-o');
export const MinusOIcon = generateIcon('icon-minus-o');
export const MinussquareOIcon = generateIcon('icon-minussquare-o');
export const MegaphoneOIcon = generateIcon('icon-megaphone-o');
export const MobileOIcon = generateIcon('icon-mobile-o');
export const MonitorOIcon = generateIcon('icon-monitor-o');
export const MinusIcon = generateIcon('icon-minus');
export const MedicalcaseOIcon = generateIcon('icon-medicalcase-o');
export const NoneIcon = generateIcon('icon-none');
export const MoreHorizIcon = generateIcon('icon-more-horiz');
export const OperationIcon = generateIcon('icon-operation');
export const OptionssquareOIcon = generateIcon('icon-optionssquare-o');
export const PencilOIcon = generateIcon('icon-pencil-o');
export const PhotoIcon = generateIcon('icon-photo');
export const PlusOIcon = generateIcon('icon-plus-o');
export const PhoneOIcon = generateIcon('icon-phone-o');
export const PriorityIcon = generateIcon('icon-priority');
export const PlussquareOIcon = generateIcon('icon-plussquare-o');
export const PrivacyOIcon = generateIcon('icon-privacy-o');
export const RepetitionIcon = generateIcon('icon-repetition');
export const SearchIcon = generateIcon('icon-search');
export const ScaleOIcon = generateIcon('icon-scale-o');
export const RefundOIcon = generateIcon('icon-refund-o');
export const ShopOIcon = generateIcon('icon-shop-o');
export const SharesquareOIcon = generateIcon('icon-sharesquare-o');
export const ShoppingbagOIcon = generateIcon('icon-shoppingbag-o');
export const ShareIcon = generateIcon('icon-share');
export const ShoppingtagOIcon = generateIcon('icon-shoppingtag-o');
export const SlashIcon = generateIcon('icon-slash');
export const ShoppingcartOIcon = generateIcon('icon-shoppingcart-o');
export const StopwatchOIcon = generateIcon('icon-stopwatch-o');
export const ShoppingbasketOIcon = generateIcon('icon-shoppingbasket-o');
export const SmileOIcon = generateIcon('icon-smile-o');
export const StretchIcon = generateIcon('icon-stretch');
export const TaskOIcon = generateIcon('icon-task-o');
export const SettingIcon = generateIcon('icon-setting');
export const SubtitlesOIcon = generateIcon('icon-subtitles-o');
export const ToLeftIcon = generateIcon('icon-to-left');
export const ToTopIcon = generateIcon('icon-to-top');
export const SubscriptionsOIcon = generateIcon('icon-subscriptions-o');
export const TransferIcon = generateIcon('icon-transfer');
export const UncheckedIcon = generateIcon('icon-unchecked');
export const UnfoldMoreIcon = generateIcon('icon-unfold-more');
export const UpOIcon = generateIcon('icon-up-o');
export const SignoutOIcon = generateIcon('icon-signout-o');
export const UploadIcon = generateIcon('icon-upload');
export const TypeIcon = generateIcon('icon-type');
export const WalletOIcon = generateIcon('icon-wallet-o');
export const VisibilityIcon = generateIcon('icon-visibility');
export const VisibilityOffIcon = generateIcon('icon-visibility-off');
export const UserOIcon = generateIcon('icon-user-o');
export const MoreVertIcon = generateIcon('icon-more-vert');
export const AddIcon = generateIcon('icon-add');
export const AccounttreeOIcon = generateIcon('icon-accounttree-o');
export const AdjustOIcon = generateIcon('icon-adjust-o');
export const ArrowdetileIcon = generateIcon('icon-arrowdetile');
export const AirplayOIcon = generateIcon('icon-airplay-o');
export const ArrowDownIcon = generateIcon('icon-arrow-down');
export const ArrowexpandOIcon = generateIcon('icon-arrowexpand-o');
export const ArrowRightIcon = generateIcon('icon-arrow-right');
export const AtmOIcon = generateIcon('icon-atm-o');
export const ArrowdownsquareOIcon = generateIcon('icon-arrowdownsquare-o');
export const AddlinkOIcon = generateIcon('icon-addlink-o');
export const ArrowupsquareOIcon = generateIcon('icon-arrowupsquare-o');
export const ArrowleftsquareOIcon = generateIcon('icon-arrowleftsquare-o');
export const AttachOIcon = generateIcon('icon-attach-o');
export const ArrowrightsquareOIcon = generateIcon('icon-arrowrightsquare-o');
export const BankOIcon = generateIcon('icon-bank-o');
export const BoxesOIcon = generateIcon('icon-boxes-o');
export const BurgermenuOIcon = generateIcon('icon-burgermenu-o');
export const BellOIcon = generateIcon('icon-bell-o');
export const BuildingOIcon = generateIcon('icon-building-o');
export const BackIcon = generateIcon('icon-back');
export const BrightnessdownOIcon = generateIcon('icon-brightnessdown-o');
export const BadgediscountOIcon = generateIcon('icon-badgediscount-o');
export const BrightnessupOIcon = generateIcon('icon-brightnessup-o');
export const CalculateOIcon = generateIcon('icon-calculate-o');
export const CalculatorOIcon = generateIcon('icon-calculator-o');
export const CalendarIcon = generateIcon('icon-calendar');
export const CameraOIcon = generateIcon('icon-camera-o');
export const ChevronDownIcon = generateIcon('icon-chevron-down');
export const CheckIcon = generateIcon('icon-check');
export const ChevronLeftIcon = generateIcon('icon-chevron-left');
export const BookmarkOIcon = generateIcon('icon-bookmark-o');
export const ChevronUpIcon = generateIcon('icon-chevron-up');
export const ChevronRightIcon = generateIcon('icon-chevron-right');
export const CircleandsquareOIcon = generateIcon('icon-circleandsquare-o');
export const ClockIcon = generateIcon('icon-clock');
export const CloseIcon = generateIcon('icon-close');
export const CoinOIcon = generateIcon('icon-coin-o');
export const ChecksingleIcon = generateIcon('icon-checksingle');
export const ChatIcon = generateIcon('icon-chat');
export const ControlOIcon = generateIcon('icon-control-o');
export const CoinsOIcon = generateIcon('icon-coins-o');
export const CloseCircleIcon = generateIcon('icon-close-circle');
export const ClosesquareOIcon = generateIcon('icon-closesquare-o');
export const CopyIcon = generateIcon('icon-copy');
export const CreditcardOIcon = generateIcon('icon-creditcard-o');
export const DeleteIcon = generateIcon('icon-delete');
export const CustomerserviceOIcon = generateIcon('icon-customerservice-o');
export const DeviceOIcon = generateIcon('icon-device-o');
export const DoubleArrowDownIcon = generateIcon('icon-double-arrow-down');
export const CreategroupOIcon = generateIcon('icon-creategroup-o');
export const DialpadIcon = generateIcon('icon-dialpad');
export const DiscountOIcon = generateIcon('icon-discount-o');
export const DoubleArrowRightIcon = generateIcon('icon-double-arrow-right');
export const DoubleArrowUpIcon = generateIcon('icon-double-arrow-up');
export const DownOIcon = generateIcon('icon-down-o');
export const DoubleArrowLeftIcon = generateIcon('icon-double-arrow-left');
export const DragverticalIcon = generateIcon('icon-dragvertical');
export const EditsquareOIcon = generateIcon('icon-editsquare-o');
export const DownloadIcon = generateIcon('icon-download');
export const FilechartOIcon = generateIcon('icon-filechart-o');
export const EmailIcon = generateIcon('icon-email');
export const FavoriteIcon = generateIcon('icon-favorite');
export const FilealertOIcon = generateIcon('icon-filealert-o');
export const FileChartOIcon = generateIcon('icon-file-chart-o');
export const FilecrossOIcon = generateIcon('icon-filecross-o');
export const EditIcon = generateIcon('icon-edit');
export const FilecheckOIcon = generateIcon('icon-filecheck-o');
export const FileminusOIcon = generateIcon('icon-fileminus-o');
export const FilecodeOIcon = generateIcon('icon-filecode-o');
export const FiledownloadOIcon = generateIcon('icon-filedownload-o');
export const FilesearchOIcon = generateIcon('icon-filesearch-o');
export const FiledocumentOIcon = generateIcon('icon-filedocument-o');
export const FileplusOIcon = generateIcon('icon-fileplus-o');
export const FlagOIcon = generateIcon('icon-flag-o');
export const FilterlistOIcon = generateIcon('icon-filterlist-o');
export const FileuploadOIcon = generateIcon('icon-fileupload-o');
export const FolderIcon = generateIcon('icon-folder');
export const HelpIcon = generateIcon('icon-help');
export const FlipchartOIcon = generateIcon('icon-flipchart-o');
export const GlobeOIcon = generateIcon('icon-globe-o');
export const HomeOIcon = generateIcon('icon-home-o');
export const HourglassOIcon = generateIcon('icon-hourglass-o');
export const AccounttreeFIcon = generateIcon('icon-accounttree-f');
export const ArchiveFIcon = generateIcon('icon-archive-f');
export const AirplayFIcon = generateIcon('icon-airplay-f');
export const AdjustFIcon = generateIcon('icon-adjust-f');
export const ArrowupsquareFIcon = generateIcon('icon-arrowupsquare-f');
export const ArrowleftsquareFIcon = generateIcon('icon-arrowleftsquare-f');
export const ArrowUpFIcon = generateIcon('icon-arrow-up-f');
export const ArrowdownsquareFIcon = generateIcon('icon-arrowdownsquare-f');
export const ArrowrightsquareFIcon = generateIcon('icon-arrowrightsquare-f');
export const ArrowRightFIcon = generateIcon('icon-arrow-right-f');
export const BurgerFIcon = generateIcon('icon-burger-f');
export const BankFIcon = generateIcon('icon-bank-f');
export const ArrowLeftFIcon = generateIcon('icon-arrow-left-f');
export const CalculatorFIcon = generateIcon('icon-calculator-f');
export const CalendarFIcon = generateIcon('icon-calendar-f');
export const CandlesticksIcon = generateIcon('icon-candlesticks');
export const ClockFillIcon = generateIcon('icon-clock-fill');
export const BuildingFIcon = generateIcon('icon-building-f');
export const CloseFillIcon = generateIcon('icon-close-fill');
export const CoinsFIcon = generateIcon('icon-coins-f');
export const CalculateFIcon = generateIcon('icon-calculate-f');
export const ArrowDownFIcon = generateIcon('icon-arrow-down-f');
export const BoxesFIcon = generateIcon('icon-boxes-f');
export const ChatFillIcon = generateIcon('icon-chat-fill');
export const ControlFIcon = generateIcon('icon-control-f');
export const DeleteFIcon = generateIcon('icon-delete-f');
export const ClosesquareFIcon = generateIcon('icon-closesquare-f');
export const CreditcardFIcon = generateIcon('icon-creditcard-f');
export const CreategroupFillIcon = generateIcon('icon-creategroup-fill');
export const CircleIcon = generateIcon('icon-circle');
export const DownFIcon = generateIcon('icon-down-f');
export const DeviceFIcon = generateIcon('icon-device-f');
export const CheckFillIcon = generateIcon('icon-check-fill');
export const EditFIcon = generateIcon('icon-edit-f');
export const DownloadFillIcon = generateIcon('icon-download-fill');
export const EmailFIcon = generateIcon('icon-email-f');
export const CoinFIcon = generateIcon('icon-coin-f');
export const FiledownloadFIcon = generateIcon('icon-filedownload-f');
export const FileminusFIcon = generateIcon('icon-fileminus-f');
export const FileFIcon = generateIcon('icon-file-f');
export const EyeonFIcon = generateIcon('icon-eyeon-f');
export const FiledocumentFIcon = generateIcon('icon-filedocument-f');
export const FileplusFIcon = generateIcon('icon-fileplus-f');
export const FilterFIcon = generateIcon('icon-filter-f');
export const HalfCircleIcon = generateIcon('icon-half-circle');
export const GridFIcon = generateIcon('icon-grid-f');
export const FlipchartFIcon = generateIcon('icon-flipchart-f');
export const FileuploadFIcon = generateIcon('icon-fileupload-f');
export const HalfSquareIcon = generateIcon('icon-half-square');
export const InfoFillIcon = generateIcon('icon-info-fill');
export const HomeFIcon = generateIcon('icon-home-f');
export const HelpFillIcon = generateIcon('icon-help-fill');
export const GlobeFIcon = generateIcon('icon-globe-f');
export const ListFIcon = generateIcon('icon-list-f');
export const ImageFIcon = generateIcon('icon-image-f');
export const LibraryvideoFIcon = generateIcon('icon-libraryvideo-f');
export const LoadingFIcon = generateIcon('icon-loading-f');
export const MapFIcon = generateIcon('icon-map-f');
export const LocationarrowFIcon = generateIcon('icon-locationarrow-f');
export const LockFIcon = generateIcon('icon-lock-f');
export const MicrophoneFIcon = generateIcon('icon-microphone-f');
export const PauseFIcon = generateIcon('icon-pause-f');
export const PersonalInfoFillIcon = generateIcon('icon-personal-info-fill');
export const MapmarkerFIcon = generateIcon('icon-mapmarker-f');
export const MedalFIcon = generateIcon('icon-medal-f');
export const PhoneFIcon = generateIcon('icon-phone-f');
export const MusicFIcon = generateIcon('icon-music-f');
export const RemoveFillIcon = generateIcon('icon-remove-fill');
export const OptionssquareFIcon = generateIcon('icon-optionssquare-f');
export const PlussquareFIcon = generateIcon('icon-plussquare-f');
export const MinussquareFIcon = generateIcon('icon-minussquare-f');
export const PaypalIcon = generateIcon('icon-paypal');
export const ShoppingbasketFIcon = generateIcon('icon-shoppingbasket-f');
export const RouteIcon = generateIcon('icon-route');
export const SharesquareFIcon = generateIcon('icon-sharesquare-f');
export const SignoutFIcon = generateIcon('icon-signout-f');
export const SortIcon = generateIcon('icon-sort');
export const MedicalchartFIcon = generateIcon('icon-medicalchart-f');
export const UmbrellaFIcon = generateIcon('icon-umbrella-f');
export const UnfoldMoreFIcon = generateIcon('icon-unfold-more-f');
export const StarIcon = generateIcon('icon-star');
export const StopFIcon = generateIcon('icon-stop-f');
export const PlayFIcon = generateIcon('icon-play-f');
export const ShoppingtagFIcon = generateIcon('icon-shoppingtag-f');
export const VolumedownFIcon = generateIcon('icon-volumedown-f');
export const VolumeupFIcon = generateIcon('icon-volumeup-f');
export const VolumemuteFIcon = generateIcon('icon-volumemute-f');
export const UpFIcon = generateIcon('icon-up-f');
export const ShopFIcon = generateIcon('icon-shop-f');
export const WarningFillIcon = generateIcon('icon-warning-fill');
export const VolumeFIcon = generateIcon('icon-volume-f');
export const WalletFIcon = generateIcon('icon-wallet-f');
